import { faStore, faStoreAlt, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Col, Modal, Row } from "antd";
import { isEmpty, omit } from "lodash";
import React from "react";
import { bat_per_capita_icon, census_per_capita_icon } from "../../Assets/Images";
import { Constant, CustomTable, ExportExcel, Functions, PieChart } from "../Common";
import { getPerCapitaByPolygon } from "../Common/Functions";
import MARKER_PERMISSIONS from "../../permissions/Markers.json";
import { havePermission } from "../../permissions";

const { getTenantName, FormateNumber } = Functions;
const {
	variables: { censusShops, clientShops },
	Tenant
} = Constant;
const { JAZZCASH, SUNTORY, EBM_REGIONAL, BAT_UK_INDEPENDENT, BAT_ORGANIZED, BAT_GERMANY } = Tenant;
const colors = ["#D92550", "#F7B924", "#3AC47D", "#545CD8"];
const showDownloadButton = [JAZZCASH, SUNTORY, EBM_REGIONAL];
function SaveFilter({ modelVisible, dispatch, _markers, tenant_markers, tenant, tableData, selecteddropDown }) {
	console.log({ selecteddropDown });
	const { population, sec } = tableData;

	let tileData = [];

	tileData = [
		{
			label: "Population",
			value: FormateNumber(Number(population || 0).toFixed(0)),
			color: colors[0],
			icon: faUsers
		},
		{
			label: "Census Shops",
			value: tableData[censusShops] || 0,
			color: colors[1],
			icon: faStore
		}
	];
	havePermission(MARKER_PERMISSIONS.TABLE_CLINET_SHOPS_COUNT) &&
		(tileData = [
			...tileData,
			{
				label: `${getTenantName(tenant)} Shops`,
				value: tableData[clientShops] || 0,
				color: colors[2],
				icon: faStoreAlt
			}
		]);

	// per capita tenant
	if ([BAT_UK_INDEPENDENT, BAT_ORGANIZED, BAT_GERMANY].includes(tenant)) {
		const { census_per_capita, client_per_capita } = getPerCapitaByPolygon(tableData, tenant);

		tileData = [
			...tileData,
			{
				label: "Population / Census Shop",
				value: FormateNumber(Number(census_per_capita || 0)),
				color: colors[3],
				icon: census_per_capita_icon,
				customIcon: true
			},
			{
				label: `Population / BAT Shop`,
				value: FormateNumber(Number(client_per_capita || 0)),
				color: colors[3],
				icon: bat_per_capita_icon,
				customIcon: true
			}
		];
	}
	return (
		<Modal
			className=" Stats-modal"
			width={"80%"}
			// title="Stats"
			visible={modelVisible}
			footer={null}
			onCancel={() =>
				dispatch({
					type: "setObject",
					actions: {
						set: {
							modelVisible: false
						}
					}
				})
			}
		>
			<Row className="w-100  mb-2" justify="center" gutter={[16, 16]}>
				{tileData.map(item => {
					return (
						<Col span={8} className="modal-stat">
							{getTileBlock(item)}
						</Col>
					);
				})}

				{!isEmpty(sec) && (
					<Col span={8} className="modal-stat">
						<div className="widget-chart">
							<h4 className="mb-0 text-muted text-center">Shopper Profile</h4>
							<PieChart data={sec} />
						</div>
					</Col>
				)}
			</Row>
			{havePermission(MARKER_PERMISSIONS.TABLE_CLINET_SHOPS_COUNT) && (
				<Card
					className="px-0"
					title={`${getTenantName(tenant)} Shops`}
					extra={
						<>
							{showDownloadButton.includes(tenant) && (
								<ExportExcel
									disable={false}
									getRoutesData={() => {
										return tenant_markers?.map(({ data }) => data) || [];
									}}
									fileName={`${getTenantName(tenant)} Shops`}
									buttonName={`Export Data`}
								/>
							)}
						</>
					}
				>
					<CustomTable
						className="modat-tbl-header b"
						data={tenant_markers?.map(({ data }) => data) || []}
						Fascia={false}
						tenant={tenant}
					/>
				</Card>
			)}

			<Card
				className="px-0"
				title="Census Shops"
				extra={
					<>
						{showDownloadButton.includes(tenant) && (
							<ExportExcel
								disable={false}
								getRoutesData={() => {
									return _markers?.map(({ data }) => omit(data, ["Fascia"])) || [];
								}}
								fileName={`Census Shops`}
								buttonName={`Export Data`}
							/>
						)}
					</>
				}
			>
				<CustomTable
					className="modat-tbl-header b"
					data={_markers?.map(({ data }) => data) || []}
					Fascia={true}
					tenant={tenant}
				/>
			</Card>
		</Modal>
	);
}

export default SaveFilter;
function getTileBlock({ label, value, icon, color, customIcon }) {
	return (
		<div className="widget-chart d-flex flex-column align-items-center justify-content-center h-100Px">
			<h4 className="mb-3 text-muted">{label}</h4>
			<div className="icon-wrapper icon-wrapper-84 rounded-circle my-3">
				<div className="icon-wrapper-bg" style={{ background: `${color}AA` }} />
				{customIcon && <img className="manImg" src={icon} alt="No Source"></img>}
				{!customIcon && (
					<FontAwesomeIcon className="icon-wrapper" icon={icon} style={{ color: `${color}`, fontSize: 70 }} />
				)}
				{/* <FontAwesomeIcon className="icon-wrapper" icon={icon} style={{ color: `${color}`, fontSize: 70 }} /> */}
			</div>
			<div className="widget-numbers text-muted">{FormateNumber(value)}</div>
		</div>
	);
}
